var $4e581a2e001ceac4$exports = {};
$4e581a2e001ceac4$exports = {
    "loading": `L\xe4ser in...`,
    "loadingMore": `L\xe4ser in mer...`
};


export {$4e581a2e001ceac4$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
